import { render, staticRenderFns } from "./StoreCommunityForm.vue?vue&type=template&id=fc2f6246&"
import script from "./StoreCommunityForm.vue?vue&type=script&lang=js&"
export * from "./StoreCommunityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports